import productEnum from "./modules/productEnum";
import customerTypeEnum from "./modules/customerTypeEnum";
import forceEanByAgentEnum from "./modules/forceEanByAgentEnum";
import productCodeDiscountDynamic from "./modules/productCodeDiscountDynamic";

export default {
  productEnum,
  customerTypeEnum,
  forceEanByAgentEnum,
  productCodeDiscountDynamic
}



// WEBPACK FOOTER //
// ./src/enums/index.js